<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import documentapi from "@/functions/api/documentapi";
  import { Route } from "svelte-router-spa";
  import { Container, Table } from "sveltestrap";
  import Subnav from "./component/subnav-case.svelte";

  import Cookies from "js-cookie";
  import moment from "moment";

  export let currentRoute;

  let listpromise;
  let doclist;
  let code;

  $: {
    code = currentRoute.namedParams.code as string;
    listpromise = documentapi.list(code);
    listpromise.then((r) => (doclist = r));
  }
  let isauth = Cookies.get("auth");

  function getImages(string) {
    const imgRex = /<img[^>]+src="([^">]+)/g;

    const images = [];
    let img;
    while ((img = imgRex.exec(string))) {
      console.log(img);
      images.push(img[1]);
      break;
    }
    return images;
  }
</script>

<Spacer size="10rem" />

<Subnav {currentRoute} />

<Container>
  <!-- <div class="search" style="height: 70px;">
    <div style="float: left;margin-top: 20px; display: none">
      <div style="display: inline-block;">Total&nbsp;</div>
      <div style="display: inline-block;" class="maxnum">97</div>
    </div>
    <div style="float: right; display: inline-block;">
      <input
        autocomplete="off"
        type="text"
        name="keyword"
        placeholder="search…"
        value=""
        class="input"
        style="border: none;width: 212px; vertical-align: top;
    
    height: 29px;
    padding: 3px 20px;
    color: #858585;
    font-size: 13px;
    line-height: 52px;
    border: none;
    box-sizing: border-box; padding-top: 7px;
    border-radius: 20px;margin-top: 20px;margin-right: -3px;background: #eeeeee"
      /><button
        type="submit"
        class="customer-qna-search__button"
        style="vertical-align: top;
    width: 54px;
    height: 42px;
    /* margin-right: -11px; */
    background: url('/images/board/search_icon.png') no-repeat 50%;border: none;margin-top: 14px;"
        ><span class="customer-qna-search__text" style="display: none;"
          >검색</span
        ></button
      >
    </div>
  </div> -->
  {#await listpromise then fetched}
    {#if code.indexOf("pf") == -1}
      <h1>{fetched.boardList.find((x) => x.code == code).name}</h1>
      <div class="mb-4" />
      <Table>
        <thead>
          <tr>
            <th width="80">이미지</th>
            <th>제목</th>
            <th style="width:8rem;" class="text-center">등록일</th>
          </tr>
        </thead>
        <tbody>
          {#each fetched.documentList.sort((a, b) => b.ts - a.ts) as doc}
            {@const images = getImages(doc.contents)}
            <tr style="height: 115px;">
              <td>
                {#if images.length > 0}
                  <img
                    src={images[0]}
                    style="max-height:140px; max-width:140px;"
                    alt="게시물 내 이미지"
                  />
                {/if}
              </td>
              <td>
                <a href={`/board/detail/${doc.sk}`} style="font-size: 18px;">
                  {doc.title}
                </a>
              </td>

              <td class="text-center" style="font-size: 18px;"
                >{moment(doc.ts).format("YYYY-MM-DD")}</td
              >
            </tr>
          {/each}
        </tbody>
      </Table>
    {:else}
      <!-- <div>포트폴리오 게시판입니다.</div> -->
      <div>
        <ul class="board_thumb_list clearfix">
          {#each fetched.documentList.sort((a, b) => b.ts - a.ts) as doc}
            {@const images = getImages(doc.contents)}
            <li>
              <a href={`/board/detail/${doc.sk}`} class="thumb_box">
                {#if images.length > 0}
                  <img src={images[0]} alt="게시물 내 이미지" />
                {/if}
              </a>
              <div class="tit_box">
                <strong class="thumb_tit">
                  <a href="#" class="thumb_box" /><a
                    href={`/board/detail/${doc.sk}`}
                    style="display: block;">{doc.title}</a
                  >
                </strong>
                <span class="upload_year"
                  >{moment(doc.ts).format("YYYY-MM-DD")}</span
                >
              </div>
            </li>
          {/each}
        </ul>
      </div>
    {/if}
    {#if isauth == "true"}
      <a href="/board/write/{code}" style="color: white;" class="btn btn-dark">
        작성하기
      </a>
    {/if}
  {:catch}
    <h3>없는 게시판 입니다</h3>
  {/await}
</Container>
<Spacer size="10rem" />

<Route {currentRoute} />

<style>
  a {
    text-decoration: none;
    color: inherit;
  }
  table tbody tr {
    vertical-align: middle;
  }
</style>
